import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary capturó un error:", error, errorInfo);
  }

  handleRetry = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            width: "100vw",
            background: "linear-gradient(180deg, #001019 18.65%, #014e7a 86.55%)",
            fontFamily: "sans-serif",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <img
            src="/assets/images/empresa/IsoLogo.png"
            alt="Logo"
            style={{ marginBottom: "40px", width: "200px" }}
          />
          <h2
            style={{
              color: "#FFFFFF",
              marginBottom: "12px",
              fontSize: "22px",
              fontWeight: "600",
            }}
          >
            Esta pagina no esta disponible
          </h2>
          <p
            style={{
              color: "#CCCCCC",
              marginBottom: "32px",
              fontSize: "16px",
              maxWidth: "400px",
              lineHeight: "1.5",
            }}
          >
            La pagina que esta solicitando no se encuentra disponible o se ha
            producido algun inconveniente.
          </p>
          <button
            onClick={this.handleRetry}
            style={{
              padding: "14px 40px",
              fontSize: "16px",
              fontWeight: "600",
              backgroundColor: "#FF6B00",
              color: "#FFFFFF",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Reintentar
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
